import { CustomInput } from './CustomInput'

const textCellFormatter = (props) => props.value;
const decimalCellFormatter = (props) => (+props.value).toPrecision(3);
const numberCellFormatter = (props) => +props.value;
const floatCellFormatter = (props) => (Math.round((+props.value) * 100) / 100).toFixed(2);
const dateCellFormatter = (props) => {
  const date = new Date(props.value);
  return date.toLocaleDateString();
}

function floatSorter(rowA, rowB, id, desc) {
  let a = Number.parseFloat(rowA.values[id]);
  let b = Number.parseFloat(rowB.values[id]);
  
  if (Number.isNaN(a)) {  // Blanks and non-numeric strings to bottom
      a = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
  }
  if (Number.isNaN(b)) {
      b = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
  }
  if (a > b) return 1; 
  if (a < b) return -1;
  return 0;
}

const numberSorter = (rowA, rowB, id, desc) => {

  let a = Number(rowA.values[id]);
  let b = Number(rowB.values[id]);

  if (Number.isNaN(a)) {  // Blanks and non-numeric strings to bottom
      a = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
  }
  if (Number.isNaN(b)) {
      b = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
  }
  if (a > b) return 1; 
  if (a < b) return -1;

  return 0;
};
  
const ColumnFilter = ({ column: { filterValue, setFilter, filter } }) => {
  return (
    <CustomInput
      value={filterValue || ""}
      onChange={e => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${filter ? filter : ""}...`}
    />
  );
};

const defaultColumns = {
  name: {
    Header: "Name", 
    accessor: "name",
    Cell: textCellFormatter,
    Filter: ColumnFilter, 
    disableFilters: false,
    dateType: false,
  },
  description: { 
    Header: "Description", 
    accessor: "description", 
    Cell: textCellFormatter, 
    Filter: ColumnFilter, 
    disableFilters: false,
    dateType: false,
  }, 
  members: {
    Header: "Members", 
    accessor: "members", 
    Cell: numberCellFormatter, 
    disableFilters: true,
    dateType: false,
  },
  id: {
    Header: "ID",
    Cell: row => { 
      const index = row.cell.row.index;
      const indexNew = row.sortedRows.map((item, i) => 
        item.index === row.cell.row.index ? i : null).filter(item => 
          item !== null)[0];
      return <div>{indexNew + 1}</div>; },
    sortable: false,
    dateType: false,
  },
  resource_mos: {
    Header: "Required Resources in Number of Months",
    accessor: "resource_mos", 
    Cell: floatCellFormatter, 
    disableFilters: false,
    dateType: false,
  },
  deadline: {
    Header: "Deadline",
    accessor: "deadline",
    Cell: dateCellFormatter,
    disableFilters: true,
    sortable: false,
    dateType: true,
  }
}

const commonColumns = [
  defaultColumns.id,
  defaultColumns.name,
  defaultColumns.description,
];

const projectColumns = [
  defaultColumns.id,
  defaultColumns.name,
  defaultColumns.description,
  defaultColumns.deadline,
];

const teamColumns = [
  defaultColumns.id,
  defaultColumns.name,
  defaultColumns.description,
  defaultColumns.members,
];

const shirtColumns = [
  defaultColumns.id,
  defaultColumns.name,
  defaultColumns.resource_mos
];


export { commonColumns, teamColumns, shirtColumns, projectColumns };

